import { Container } from '@components/layout/Grid';
import { Title } from '@ecosystems/landing_pages/hero/components';
import { BundleQuery, Query } from '@gql/generated';
import { cn } from '@lib/tw';

const Element = ({ className = '', title, content }) => {
  return (
    <div
      className={cn('first-letter:capitalize TextSection--Element', className)}
    >
      <div className="TextSection--ElementContent">
        <Title as="h3" className="!font-medium !text-xl !mb-0">
          {title}
        </Title>
        <div className="TextSection--ElementInnerContent pt-2">{content}</div>
      </div>
    </div>
  );
};

type Props = {
  content: BundleQuery['bundle']['twoColumnsSection'];
};

export const TextSection = ({ content }: Props) => {
  return (
    <Container flexDirection="column" fullWidth py={40} px={20}>
      <Container flexDirection="column">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-12 Section--TwoColumn">
          <div className="flex flex-col mb-8">
            <Title as="h2" className="!mb-2 !text-2xl">
              {content.title}
            </Title>
            <div
              className="text-lg mb-0 mt-0"
              dangerouslySetInnerHTML={{
                __html: content.subtitle,
              }}
            ></div>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-20 Section--TwoColumn">
          <div
            className="flex flex-col md:pr-10"
            dangerouslySetInnerHTML={{
              __html: content.leftContent,
            }}
          ></div>
          <div
            className="flex flex-col md:pr-10"
            dangerouslySetInnerHTML={{
              __html: content.rightContent,
            }}
          ></div>
        </div>
      </Container>
    </Container>
  );
};
